import { render, staticRenderFns } from "./dashboard-serviceorders.vue?vue&type=template&id=0bb65290&scoped=true&"
import script from "./dashboard-serviceorders.vue?vue&type=script&lang=js&"
export * from "./dashboard-serviceorders.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-serviceorders.vue?vue&type=style&index=0&id=0bb65290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb65290",
  null
  
)

export default component.exports